import React from 'react';

interface ViewToggleProps {
    currentView: 'week' | 'month';
    onViewChange: (view: 'week' | 'month') => void;
}

export const ViewToggle: React.FC<ViewToggleProps> = ({ currentView, onViewChange }) => {
    return (
        <div className="flex bg-gray-100 rounded-lg p-1">
            <button
                onClick={() => onViewChange('week')}
                className={`px-4 py-2 text-sm font-medium rounded-md transition-colors ${
                    currentView === 'week'
                        ? 'bg-white text-gray-900 shadow-sm'
                        : 'text-gray-600 hover:text-gray-900'
                }`}
            >
                Vue semaine
            </button>
            <button
                onClick={() => onViewChange('month')}
                className={`px-4 py-2 text-sm font-medium rounded-md transition-colors ${
                    currentView === 'month'
                        ? 'bg-white text-gray-900 shadow-sm'
                        : 'text-gray-600 hover:text-gray-900'
                }`}
            >
                Vue mensuelle
            </button>
        </div>
    );
};